import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import Chip from "@material-ui/core/Chip";
import toastError from "../../errors/toastError";
import api from "../../services/api";
import { i18n } from "../../translate/i18n";
import { QueueChip, QueueOptionLabel, queueMenuProps } from "../QueueSelect";

const useStyles = makeStyles(() => ({
	chips: {
		display: "flex",
		flexWrap: "wrap",
		gap: 4,
	},
}));

// `margin="none"` é para quem hospeda o campo numa grade (sem o respiro legado de 6 px + dense).
const QueueSelectCustom = ({ selectedQueueIds, onChange, margin = "dense" }) => {
	const classes = useStyles();
	const [queues, setQueues] = useState([]);

	useEffect(() => {
		(async () => {
			try {
				const { data } = await api.get("/queue");
				setQueues(data);
			} catch (err) {
				toastError(err);
			}
		})();
	}, []);

	const handleChange = e => {
		onChange(e.target.value);
	};

	return (
		<div style={margin === "none" ? undefined : { marginTop: 6 }}>
			<FormControl fullWidth margin={margin} variant="outlined">
				<InputLabel id="queue-select-custom-label">{i18n.t("queueSelect.inputLabel")}</InputLabel>
				<Select
					multiple
					labelId="queue-select-custom-label"
					label={i18n.t("queueSelect.inputLabel")}
					value={selectedQueueIds}
					onChange={handleChange}
					MenuProps={queueMenuProps}
					renderValue={selected => (
						<div className={classes.chips}>
							{selected?.length > 0 &&
								selected.map(id => {
									if (id === "0") {
										return (
											<Chip
												key={id}
												size="small"
												label={i18n.t("queueSelect.withoutQueue")}
											/>
										);
									}
									const queue = queues.find(q => q.id === id);
									return queue ? <QueueChip key={id} queue={queue} /> : null;
								})}
						</div>
					)}
				>
					<MenuItem value="0">
						{i18n.t("queueSelect.withoutQueue")}
					</MenuItem>
					{queues.map(queue => (
						<MenuItem key={queue.id} value={queue.id}>
							<QueueOptionLabel queue={queue} />
						</MenuItem>
					))}
				</Select>
			</FormControl>
		</div>
	);
};

export default QueueSelectCustom;
